export default "__VITE_ASSET__z8kEmi28__"